module.exports = __webpack_public_path__ + "img/3d.98a59022.png";